angular.module('wbDirectives').directive 'wbFloatLabel', ['$timeout', ($timeout) ->
  restrict: 'A'
  require: 'ngModel'
  link: ($scope, $el, $attrs, ngModel) ->
    return unless ngModel? and $attrs.placeholder?
    placeholder = $attrs.placeholder
    floatLabel = $("<div class='float-label'>#{$attrs.placeholder}</div>")
    $el.after(floatLabel)

    changed = (value) ->
      if !value or value is ''
        floatLabel.removeClass('float-label-visible')
        $el.removeClass('float-label-visible')
      else
        floatLabel.addClass('float-label-visible')
        $el.addClass('float-label-visible')
      # Ensures that we don't animate the initial state of the label
      return value

    changedByCode = (value) ->
      if _.isEmpty(value)
        # Remove float label when the value is empty
        floatLabel.removeClass('float-label-visible')
        $el.removeClass('float-label-visible')
      return value

    ngModel.$parsers.push(changed)
    ngModel.$formatters.unshift(changedByCode)
    $timeout ->
      $el.addClass('float-label-initialized')
      floatLabel.addClass('float-label-initialized')
    , 100
]
